import Button from '@egalite/ui/Buttons';
import { FC } from 'react';
import Icon from '../../Icon';
import clx from 'classnames';

const NavbarLoginButton: FC = () => (
	<div className="group relative">
		<Button type="link" href='/login' icon={<Icon name="login" className="text-white" />} size="small" md="large" className="gap-4 px-6 md:px-10 peer">
			Login
		</Button>
	</div>
);

export default NavbarLoginButton;
